import React from 'react';
import {TablePagination} from "@mui/material";


interface ITablesPaginationProps {
    totalCount: number,
    itemsPerPage: number,
    pageNumber: number,
    handleChangePage: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, newPage: number) => void,
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

const TablesPagination: React.FC<ITablesPaginationProps> = (
    {
        totalCount,
        itemsPerPage,
        pageNumber,
        handleChangePage,
        handleChangeRowsPerPage
    }) => {
    return (
        <TablePagination
            sx={(theme) => ({
                backgroundColor: theme.palette.mode === 'dark' ? "#292929" : "#f0f0f0"
            })}
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={itemsPerPage}
            page={pageNumber - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    );
};

export default TablesPagination;
